import NTooltip from './NTooltip';
export default NTooltip;